var map = {
	"./686-magnum.png": 966,
	"./93r.png": 7608,
	"./aa-12.png": 5350,
	"./acr.png": 8550,
	"./ak-47.png": 3593,
	"./d50.png": 6818,
	"./double-barreled.png": 7085,
	"./m16a4.png": 3735,
	"./m1911.png": 9556,
	"./m249.png": 9471,
	"./m44.png": 5163,
	"./m4a1.png": 5803,
	"./m60.png": 9819,
	"./m870.png": 2556,
	"./m9.png": 4456,
	"./mdr.png": 251,
	"./mk-20-ssr.png": 2781,
	"./mp5a2.png": 1723,
	"./mp7.png": 6568,
	"./outline/686-magnum.png": 8260,
	"./outline/93r.png": 9881,
	"./outline/aa-12.png": 1602,
	"./outline/acr.png": 473,
	"./outline/ak-47.png": 5369,
	"./outline/d50.png": 3654,
	"./outline/double-barreled.png": 6284,
	"./outline/m16a4.png": 8918,
	"./outline/m1911.png": 658,
	"./outline/m249.png": 7281,
	"./outline/m44.png": 206,
	"./outline/m4a1.png": 386,
	"./outline/m60.png": 9808,
	"./outline/m870.png": 2697,
	"./outline/m9.png": 6989,
	"./outline/mdr.png": 4796,
	"./outline/mk-20-ssr.png": 7751,
	"./outline/mp5a2.png": 5071,
	"./outline/mp7.png": 5428,
	"./outline/p90.png": 6536,
	"./outline/rpk-74.png": 1061,
	"./outline/svd.png": 2322,
	"./outline/tac-50.png": 3079,
	"./outline/vector-45.png": 6637,
	"./p90.png": 9661,
	"./rpk-74.png": 4458,
	"./svd.png": 653,
	"./tac-50.png": 9952,
	"./vector-45.png": 7365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6827;